import React, { useState } from 'react';
import Vendor from './Vendor';

interface ITaranaVendorCardsProps {
  selectedTaranaVendorId: string | number;
  selectedCpeVendorId: string | number;
  onTaranaChange: any;
  onCpeChange: any;
  taranaOptions: any[];
  cpeOptions: any[];
  refresh: any;
  processing: any;
}

const TaranaVendorCards: React.FC<ITaranaVendorCardsProps> = (props) => {
  const [activeTab, setActiveTab] = useState<string>('base_node');
  return (
    <div>
      <div className="vendor-title text-color p-3">Vendor</div>
      <div className="mt-3 row-wise w-100 px-3">
        <div
          id="cbsd-vendors"
          onClick={() => {
            setActiveTab('base_node');
          }}
          className={
            'border-left w-50 vertical-center text-color center cursor-pointer ' +
            `${activeTab === 'base_node' ? 'border-active ' : 'border-inactive '}`
          }>
          {'Base Node'}
        </div>
        <div
          id="cpe-vendors"
          onClick={() => {
            setActiveTab('remote_node');
          }}
          className={
            'border-right w-50 vertical-center text-color center cursor-pointer ' +
            `${activeTab === 'remote_node' ? 'border-active ' : 'border-inactive '}`
          }>
          {'Remote Node'}
        </div>
      </div>
      {activeTab == 'base_node' && (
        <div className="row gx-0">
          <div className="px-3">
            <Vendor
              title="Base Node"
              type="tarana"
              processing={props.processing}
              selectedVendorId={props.selectedTaranaVendorId}
              options={props.taranaOptions}
              refresh={props.refresh}
              onChange={props.onTaranaChange}
            />
          </div>
        </div>
      )}

      {activeTab == 'remote_node' && (
        <div className="row gx-0">
          <div className="px-3">
            <Vendor
              title="Remote Node"
              type="tarana_cpe"
              processing={props.processing}
              selectedVendorId={props.selectedCpeVendorId}
              options={props.cpeOptions}
              refresh={props.refresh}
              onChange={props.onCpeChange}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TaranaVendorCards;
